// ─────────────────────────────────────────
// ts/env.ts — Runtime configuration
// Single source of truth for all environment-dependent
// values. Edit these before deploying.
// Tauvior Landing Page
// ─────────────────────────────────────────

/**
 * Contact form submission endpoint.
 *
 * Supported providers (uncomment the one you use):
 *
 * ── Formspree ──────────────────────────────────────────────────────────────
 * Sign up at https://formspree.io, create a form, copy the endpoint:
 *   FORM_ENDPOINT: 'https://formspree.io/f/YOUR_FORM_ID'
 *
 * ── Netlify Forms ──────────────────────────────────────────────────────────
 * Add netlify attribute to the <form> tag in index.html:
 *   <form id="contact-form" netlify novalidate>
 * Then set endpoint to '' and let Netlify handle submission natively.
 *
 * ── Custom backend ─────────────────────────────────────────────────────────
 * Point to your own REST endpoint that accepts POST with JSON body:
 *   { name, email, company, interest, message, locale, source }
 *
 * ── Development / staging ──────────────────────────────────────────────────
 * Leave as empty string to use the built-in mock (logs payload to console).
 */
export const FORM_ENDPOINT = 'https://formspree.io/f/mreorgwb';

/**
 * Contact email address — shown as fallback in error messages.
 */
export const CONTACT_EMAIL = 'contato@tauvior.com';

/**
 * Minimum number of characters required in the message field.
 */
export const MESSAGE_MIN_LENGTH = 20;

/**
 * Duration (ms) before the success feedback auto-hides.
 */
export const FEEDBACK_AUTO_HIDE_MS = 6_000;

/**
 * Current build environment.
 * Vite replaces import.meta.env.MODE at build time.
 */
export const IS_DEV = import.meta.env.MODE === 'development';
